import { useHasLicenseAccess } from "@/components/LicenseGuard/useHasLicenseAccess";
import { useCall } from "../useCall/useCall";

import { FEATURE_NAME } from "@/components/LicenseGuard/LicenseGuard.constant";
import { useHasSentimentAnalysis } from "@/hooks/useHasSentimentAnalysis/useHasSentimentAnalysis";

export function useCallContextRule() {
  const { call } = useCall();

  const hasEvaluationTabAccess = useHasLicenseAccess({
    feature: FEATURE_NAME.EVALUATION_TAB_ACCESS,
  });
  const hasSentimentAnalysis = useHasSentimentAnalysis();

  const shouldDisplayInsights = [
    call?.type !== undefined && call.type !== "voicemail",
    call?.transcription?.status === "available",
  ].every(Boolean);

  return {
    // if true, we display summary, key topics and talk ratios, BUT the content could be NOT GENERATED YET
    shouldDisplayInsights,
    // if true, we display the sentiment section, BUT it could be EMPTY if sentiment is not generated for an old call
    shouldDisplaySentiments: hasSentimentAnalysis,
    // if true, we display the talk ratio, which is not empty
    isTalkRatioDisplayed:
      shouldDisplayInsights &&
      call?.transcription?.__typename === "CallTranscription" &&
      (call.transcription.content?.utterances?.length ?? 0) > 0 &&
      (call.transcription?.content?.speakers?.length ?? 0) > 0,
    shouldDisplayEvaluation: hasEvaluationTabAccess,
  };
}
